/**
 * Inline 5-star rendering. Half-stars via clipPath; no emoji.
 */

import { useTranslation } from 'react-i18next';

export function RatingStars({ value, size = 14 }: { value: number; size?: number }) {
  const { t } = useTranslation('marketplace');
  const clamped = Math.max(0, Math.min(5, value));
  const pct = (clamped / 5) * 100;
  return (
    <span
      role="img"
      aria-label={t('card.rating_aria', { rating: clamped.toFixed(1) })}
      className="relative inline-flex"
      style={{ width: size * 5, height: size }}
    >
      {/* Muted background layer */}
      <Row size={size} filled={false} />
      {/* Foreground layer clipped to the percentage */}
      <span
        aria-hidden="true"
        className="absolute inset-0 overflow-hidden"
        style={{ width: `${pct}%` }}
      >
        <Row size={size} filled />
      </span>
    </span>
  );
}

function Row({ size, filled }: { size: number; filled: boolean }) {
  return (
    <span className="flex gap-0.5">
      {Array.from({ length: 5 }).map((_, i) => (
        <svg
          key={i}
          width={size}
          height={size}
          viewBox="0 0 20 20"
          fill={filled ? 'currentColor' : 'none'}
          stroke="currentColor"
          strokeWidth={1.4}
          className={filled ? 'text-amber-500' : 'text-ink-subtle'}
          aria-hidden="true"
        >
          <path d="M10 1.5l2.6 5.3 5.9.6-4.2 4 1.3 5.7-5.6-3.1-5.6 3.1 1.3-5.7L1.5 7.4l5.9-.6z" />
        </svg>
      ))}
    </span>
  );
}
